export default "dist/images/components-design-separator-control-rounded-1.85d0e25.png";